<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <div class="home-header">
        <img :src="imgLocal('header.png?t=20231105')" style="width:100%;">
      </div>
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="padding-bottom:0rem;"
      >
        <div class="home-user">
          <div class="headpic" @click="clickUser">
            <div>
              <van-image
                round
                width="4rem"
                height="4rem"
                :src="member.headpic"
              />
              <div class="text-center">{{ member.nickname || '请登录' }}</div>
            </div>
          </div>
          <div v-if="!stuList.length" class="order-count">
            <div class="text-center">还未绑定学籍信息~</div>
          </div>
          <div v-if="stuList.length == 1" class="order-count" @click="$router.push('/stu-main/'+ stuList[0].id)">
            <div class="text-center">我的学籍</div>
            <div class="count text-center">{{ stuList[0]._rolls.length }}</div>
          </div>
          <div v-if="stuList.length > 1" class="order-count" @click="$router.push('/stu-list')">
            <div class="text-center">学生信息</div>
            <div class="count text-center">{{ stuList.length }}</div>
          </div>
        </div>
        <van-notice-bar v-if="!this.stuList.length" mode="link" @click="$router.push('/stu-bind')">
          如已报名，点此绑定我的学籍
        </van-notice-bar>
        <van-cell-group v-if="stuList.length" :title="meTitle">
          <van-grid :column-num="2" clickable>
            <template v-if="stuList.length == 1">
              <van-grid-item v-for="item in stuList[0]._rolls" :key="item.id" :to="'/stu-roll/'+ item.id">
                <div>
                  <div style="font-size:1.1rem; font-weight:bold;">{{ item.xjname }}</div>
                  <van-tag :color="rollStatusColor(item.status)">{{ xjStatus[item.status] ? xjStatus[item.status].name : item.status }}</van-tag>
                </div>
              </van-grid-item>
            </template>
            <template v-if="stuList.length > 1">
              <van-grid-item v-for="item in stuList" :key="item.id" :to="'/stu-main/'+ item.id">
                <div>
                  <label style="font-weight:bold">{{ item.name }}</label>
                  <div><van-tag type="danger">{{ item._rolls.length }}</van-tag> 学籍</div>
                </div>
              </van-grid-item>
            </template>
          </van-grid>
        </van-cell-group>
        <div class="home-items">
          <van-cell-group title="快速报名">
            <van-grid :column-num="2" clickable>
              <van-grid-item v-for="item in xjList" :key="item.id" :text="item.name" :to="`/register/${item.id}?zsls=${zslsinfo?.id ?? ''}`" />
            </van-grid>
          </van-cell-group>
        </div>
      </van-pull-refresh>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [siteMixin],
  data() {
    return {
      error: false,
      isLoading: false,
      stuList: [],
      list: [],
    }
  },
  computed: {
    ...mapGetters({
      zslsinfo: 'zslsinfo',
      reloadWeb: [types.OTHER.reloadWeb],
      xjList: [types.BASE_LOAD.xjList],
      xjStatus: [types.BASE_LOAD.xjStatus]
    }),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        let h = this.w * 0.618 * 0.26;
        style = {height: h + 'px'};
      }
      return style;
    },
    headerBg() {
      return {'background-image':'url('+ this.assetsPath +'static/images/header-bg.png)'};
    },
    meTitle() {
      return this.stuList.length > 1 ? '我的学生' : '我的学籍';
    }
  },
  watch: {
    reloadWeb() {
      this.loadData();
    },
    'member.id'() {
      this.loadData();
    },
  },
  created () {
    this.loadData();
  },
  mounted () {
    document.title = this.sitetitle;
  },
  methods: {
    loadData(callback) {
      if (!this.xjList || !this.xjList.length) {
        this.$store.dispatch(types.BASE_LOAD.xjList);
      }
      if (!this.xjStatus || !Object.keys(this.xjStatus).length) {
        this.$store.dispatch(types.BASE_LOAD.xjStatus);
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/home',
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            let list = json.stuList || [];
            list.map(d => {
              d._rolls = d._rolls ? JSON.parse(d._rolls) : [];
            });
            this.stuList = list;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    clickUser() {
      if (this.member.id) {
        this.$router.push('/stu-list');
      } else {
        this.doLogin();
      }
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        let list = json.stuList || [];
        list.map(d => {
          d._rolls = d._rolls ? JSON.parse(d._rolls) : [];
        });
        this.stuList = list;

        this.$toast('刷新成功');
      });
    },
    doSignup(item) {
      this.$router.push('/signup/'+ item.id);
    },
    showItem(item) {
      this.$router.push('/item/'+ item.id);
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-bottom:50px;
  background-color:#f5f5f5;
}
.home-user {
  .flex-center-v();
  margin:1rem;
  padding:1rem;
  background-color:#fff;
  border-radius:1rem;
  .shadow_black(0 0 10px 0, .05);
  .headpic {
    flex-shrink: 0;
    margin-right:1.5rem;
  }
  .order-count {
    flex-grow: 1;
    padding-left: 1rem;
    border-left: 1px #eee solid;
  }
  .count {
    color:green;
    .fontsize(2rem);
  }
}
.home-items {
  // padding:0 1rem 2rem;
  h4 {
    margin:0;
    padding: 1rem;
    color:#888;
  }
  /deep/ .van-grid-item__text {
    font-size:1rem;
  }
  .item {
    .flex();
    background-color:#fff;
    border-radius:1rem;
    .shadow_black(0 0 10px 0, .05);
    .imgs {
      padding:.5rem;
      margin-right:1rem;
      width: 26%;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .detail {
      padding:.5rem;
      .tit {
        .fontsize(1.2rem);
      }
      .con {
        margin-top:.25rem;
        color:#888;
      }
      .btns {
        margin-top:.5rem;
      }
    }
  }
}
</style>